import FullScreenButton from "./FullScreenButton";
import withResponsiveUtils from "../../utils/ResponsiveUtils";

export default withResponsiveUtils(FullScreenButton);
